import { render, staticRenderFns } from "./news-search.vue?vue&type=template&id=12dbbd52&scoped=true&"
import script from "./news-search.vue?vue&type=script&lang=js&"
export * from "./news-search.vue?vue&type=script&lang=js&"
import style0 from "./news-search.vue?vue&type=style&index=0&id=12dbbd52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dbbd52",
  null
  
)

export default component.exports